import styled, { css } from 'styled-components'
import { ButtonProps } from './types'
import { ThemeColorsKeysType } from '../../Core/Styles/theme'

export const ButtonStyle = styled('button') <ButtonProps>`
  appearance: none;
  margin: ${props => props.buttonMargin || '4px 0'};
  padding: ${props => props.iconName ? '4px 9px 4px 5px' : '8px 9px'};
  color: ${props => props.theme.colors.main.blank};
  background-color: ${props => props.theme.colors.main?.[(props.color || 'main') as ThemeColorsKeysType]};
  border: ${props => props.border || ('2px solid ' + props.theme.colors.main?.[(props.color || 'main') as ThemeColorsKeysType])};
  border-radius: 4px;
  font-size: ${props => props.fontSize || '11px'};
  font-weight: bold;
  user-select: none;
  cursor: pointer;
  transition: border 100ms ease-in-out, background-color 100ms ease-in-out;

  overflow: ${props => props.overflow || 'hidden'};
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    background-color: ${props => props.theme.colors.main?.[(props.color || 'dark') as ThemeColorsKeysType]};
    border: 2px solid ${props => props.theme.colors.main?.[(props.color || 'dark') as ThemeColorsKeysType]};
  }

  &:focus {
    border: 2px solid ${props => props.theme.colors.main.ultraViolet};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${props => props.iconName && css`
    display: flex;
    align-items: center;
    justify-content: center;
  `}

  ${props => props.version === 2 && css`
    color: ${props.theme.colors.main?.[(props.color || 'main') as ThemeColorsKeysType]};
    background-color: ${props.theme.colors.main.background};
    ${props.buttonMargin && css`
      margin: ${props.buttonMargin};
    `}
    
    &:hover {
      background-color: ${props.theme.colors.shades.neutral[1]};
      border: 2px solid ${props.theme.colors.main?.[(props.color || 'dark') as ThemeColorsKeysType]};
    }
  `}

  ${props => props.version === 3 && css`
    height: 48px;
    margin: ${props.noMargin ? '0' : '24px'};
    padding: ${props.iconName ? '0 24px 0 20px' : '16px 24px'};
    color: ${props.theme.colors.main.blank};
    background-color: ${props.theme.colors.main.ultraViolet};
    border: 2px solid ${props.theme.colors.main.ultraViolet};
    border-radius: 24px;
    text-transform: ${props.noUppercase ? 'none' : 'uppercase'}

    &:hover {
      background-color: ${props.theme.colors.light.ultraViolet};
      border: 2px solid ${props.theme.colors.light.ultraViolet};
    }
  `}

  ${props => props.version === 4 && css`
    display: flex;
    height: ${props.height || '48px'};
    margin: ${props.buttonMargin || '0 0 16px'};
    padding: ${props.iconName ? '0 24px 0 20px' : '0 0 0 8px'};
    color: ${props.theme.colors.main?.[(props.color || 'ultraViolet') as ThemeColorsKeysType]};
    background-color: transparent;
    border: none;
    text-transform: uppercase;

    &:hover, &:focus {
      background-color: transparent;
      border: none;
    }
    &:hover {
      opacity: 0.5;
    }
  `}

  ${props => props.version === 5 && css`
    height: 36px;
    margin: ${props.noMargin ? '0' : (props.buttonMargin || '24px')};
    padding: ${props.iconName ? '6px 16px 6px 12px' : '6px 16px'};
    color: ${props.theme.colors.main.blank};
    background-color: ${props.disabled ? props.theme.colors.main.disabled : props.theme.colors.main.ultraViolet};
    border: 2px solid ${props.disabled ? props.theme.colors.main.disabled : props.theme.colors.main.ultraViolet};
    border-radius: 24px;
    text-transform: ${props.noUppercase ? 'none' : 'uppercase'};

    &:hover {
      background-color: ${props.disabled ? props.theme.colors.main.disabled : props.theme.colors.main.ultraViolet};
      border: 2px solid ${props.disabled ? props.theme.colors.main.disabled : props.theme.colors.main.ultraViolet}};
      cursor: ${props.disabled ? 'not-allowed' : 'pointer'};
    }

    &:focus {
      border: 2px solid ${props.theme.colors.main.ultraViolet};
    }

    &:disabled {
      opacity: 1; /* keep color fixed, opacity handled by background */
      cursor: not-allowed;
    }
  `}
`
